import { useState } from 'react';

type VideoCategory = 'hepsi' | 'motivasyon' | 'kazanc-plani' | 'egitim' | 'basari';

interface Video {
  id: string;
  title: string;
  speaker: string;
  speakerRole: string;
  category: VideoCategory;
  duration: string;
  views: string;
  description: string;
  thumbnail: string;
  youtubeId: string;
  featured?: boolean;
}

const categoryLabels: Record<VideoCategory, string> = {
  hepsi: 'Tüm Videolar',
  motivasyon: 'Motivasyon',
  'kazanc-plani': 'Kazanç Planı',
  egitim: 'Sistem Eğitimi',
  basari: 'Başarı Hikayesi',
};

const categoryIcons: Record<VideoCategory, string> = {
  hepsi: 'ri-video-line',
  motivasyon: 'ri-fire-line',
  'kazanc-plani': 'ri-money-dollar-circle-line',
  egitim: 'ri-book-open-line',
  basari: 'ri-trophy-line',
};

const categoryColors: Record<VideoCategory, string> = {
  hepsi: 'text-gray-400',
  motivasyon: 'text-orange-400',
  'kazanc-plani': 'text-amber-400',
  egitim: 'text-blue-400',
  basari: 'text-green-400',
};

const mockVideos: Video[] = [
  {
    id: '1',
    title: 'STEP6 ile Pasif Gelire Giden Yol',
    speaker: 'Ahmet Kaya',
    speakerRole: 'Üst Lider — Diamond',
    category: 'motivasyon',
    duration: '18:42',
    views: '12.4K',
    description: 'Sıfırdan başlayıp 3 yılda finansal özgürlüğe ulaşmanın gerçek hikayesi. Sistemin nasıl çalıştığını ve neden sadece 4 kişinin yeterli olduğunu dinle.',
    thumbnail: 'https://readdy.ai/api/search-image?query=professional%20business%20leader%20speaking%20on%20stage%20with%20motivational%20text%20screen%20behind%2C%20dark%20premium%20conference%20hall%2C%20golden%20spotlight%2C%20network%20marketing%20event%2C%20cinematic&width=640&height=360&seq=vid01&orientation=landscape',
    youtubeId: 'dQw4w9WgXcQ',
    featured: true,
  },
  {
    id: '2',
    title: 'Kazanç Planının Matematiği — Adım Adım',
    speaker: 'Selin Yıldız',
    speakerRole: 'Lider — Platinum',
    category: 'kazanc-plani',
    duration: '24:15',
    views: '8.7K',
    description: '1. adımdan 6. adıma kadar her seviyedeki gerçek gelir hesaplamalarını gösteriyorum. Aktiflik bedeli ne zaman karşılanır, kâr ne zaman başlar?',
    thumbnail: 'https://readdy.ai/api/search-image?query=professional%20woman%20presenting%20financial%20chart%20with%20income%20plan%20numbers%20on%20digital%20screen%2C%20dark%20office%20setting%2C%20gold%20and%20white%20colors%2C%20business%20coaching%20presentation&width=640&height=360&seq=vid02&orientation=landscape',
    youtubeId: 'dQw4w9WgXcQ',
    featured: true,
  },
  {
    id: '3',
    title: '4 Kişi Nasıl Bulunur? — Doğru Hedef Kitle',
    speaker: 'Mehmet Arslan',
    speakerRole: 'Lider — Gold',
    category: 'egitim',
    duration: '31:08',
    views: '6.2K',
    description: 'Ekibine katacağın 4 kişiyi nasıl seçersin? Hangi profil daha hızlı ilerler? 5 yıllık deneyimimle doğru kişileri belirleme yöntemlerimi paylaşıyorum.',
    thumbnail: 'https://readdy.ai/api/search-image?query=business%20coach%20teaching%20team%20selection%20strategy%20with%20whiteboard%20and%20sticky%20notes%2C%20dark%20modern%20office%2C%20navy%20and%20gold%20color%20scheme%2C%20professional%20setting&width=640&height=360&seq=vid03&orientation=landscape',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    id: '4',
    title: '6 Ayda Diamond\'a Ulaştım — Gerçek Hikayem',
    speaker: 'Fatma Demir',
    speakerRole: 'Diamond Lider',
    category: 'basari',
    duration: '15:30',
    views: '19.1K',
    description: 'Sıradan bir ev hanımıyken, STEP6 sistemiyle 6 ayda Diamond seviyesine nasıl ulaştığımı tüm detaylarıyla anlatıyorum. Hataları ve doğruları.',
    thumbnail: 'https://readdy.ai/api/search-image?query=successful%20businesswoman%20smiling%20holding%20achievement%20award%20on%20stage%2C%20dark%20luxury%20event%20backdrop%2C%20gold%20confetti%2C%20network%20marketing%20success%20story%2C%20cinematic%20lighting&width=640&height=360&seq=vid04&orientation=landscape',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    id: '5',
    title: 'WhatsApp ile Ekip Büyütme Teknikleri',
    speaker: 'Kemal Şen',
    speakerRole: 'Lider — Platinum',
    category: 'egitim',
    duration: '22:50',
    views: '5.4K',
    description: 'WhatsApp mesajlaşmasıyla ekibini nasıl büyütürsün? Doğru dil, doğru zamanlama ve doğru şablon kullanımı. Adım adım pratik eğitim.',
    thumbnail: 'https://readdy.ai/api/search-image?query=digital%20marketing%20coach%20showing%20whatsapp%20strategy%20on%20laptop%20screen%20in%20dark%20modern%20workspace%2C%20phone%20with%20messaging%20app%20visible%2C%20gold%20and%20teal%20accent%20colors&width=640&height=360&seq=vid05&orientation=landscape',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    id: '6',
    title: 'Motivasyonunu Nasıl Canlı Tutarsın?',
    speaker: 'Zeynep Koç',
    speakerRole: 'Üst Lider — Diamond',
    category: 'motivasyon',
    duration: '12:20',
    views: '10.3K',
    description: 'Network marketing yolculuğunda en büyük engel motivasyon kaybıdır. Bunu aşmanın sistematik yollarını ve zihinsel sağlamlık tekniklerini paylaşıyorum.',
    thumbnail: 'https://readdy.ai/api/search-image?query=energetic%20motivational%20speaker%20on%20dark%20stage%20with%20powerful%20spotlight%2C%20audience%20silhouettes%2C%20inspirational%20atmosphere%2C%20gold%20and%20black%20color%20palette%2C%20cinematic&width=640&height=360&seq=vid06&orientation=landscape',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    id: '7',
    title: 'Seviye Kazançlarını Anlamak — Detaylı Eğitim',
    speaker: 'Emre Güler',
    speakerRole: 'Lider — Gold',
    category: 'kazanc-plani',
    duration: '28:00',
    views: '4.8K',
    description: '1., 2. ve 3. seviye kazanç farklarını gerçek rakamlarla anlıyoruz. Ekibini katmanlaştırmak neden bu kadar önemli? Matematiksel kanıtlar.',
    thumbnail: 'https://readdy.ai/api/search-image?query=financial%20advisor%20explaining%20multi%20level%20income%20plan%20on%20glass%20board%20with%20charts%20and%20numbers%2C%20dark%20business%20environment%2C%20amber%20lighting%2C%20professional%20and%20premium%20look&width=640&height=360&seq=vid07&orientation=landscape',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    id: '8',
    title: '1 Yılda Ekibimi 64 Kişiye Büyüttüm',
    speaker: 'Hasan Yılmaz',
    speakerRole: 'Üst Lider — Diamond',
    category: 'basari',
    duration: '19:45',
    views: '14.6K',
    description: 'İlk 4 kişimi bulmaktan 3. jenerasyona kadar tüm süreci anlattım. Ekip yönetimi, kişisel gelişim ve sisteme bağlılık nasıl sağlanır?',
    thumbnail: 'https://readdy.ai/api/search-image?query=confident%20business%20leader%20standing%20in%20front%20of%20large%20team%20photo%20wall%2C%20modern%20dark%20office%20with%20gold%20accents%2C%20team%20growth%20concept%2C%20professional%20portrait&width=640&height=360&seq=vid08&orientation=landscape',
    youtubeId: 'dQw4w9WgXcQ',
  },
];

const categoryBadgeColors: Record<string, { bg: string; text: string }> = {
  motivasyon: { bg: 'rgba(255,107,53,0.12)', text: '#FB923C' },
  'kazanc-plani': { bg: 'rgba(245,166,35,0.12)', text: '#F5A623' },
  egitim: { bg: 'rgba(0,180,255,0.12)', text: '#60A5FA' },
  basari: { bg: 'rgba(34,197,94,0.12)', text: '#4ADE80' },
};

export default function LiderVideolari() {
  const [activeCategory, setActiveCategory] = useState<VideoCategory>('hepsi');
  const [playingVideo, setPlayingVideo] = useState<Video | null>(null);

  const filtered = activeCategory === 'hepsi'
    ? mockVideos
    : mockVideos.filter(v => v.category === activeCategory);

  const featured = mockVideos.filter(v => v.featured);

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-white">Lider Videoları</h1>
        <p className="text-sm text-gray-500 mt-1">Motivasyon, kazanç planı anlatımları ve sistem eğitimleri</p>
      </div>

      {/* Öne Çıkan Videolar */}
      <div>
        <div className="flex items-center gap-2 mb-4">
          <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: 'rgba(245,166,35,0.12)' }}>
            <i className="ri-star-line text-amber-400 text-sm" />
          </div>
          <h2 className="text-sm font-bold text-white">Öne Çıkan Videolar</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {featured.map(video => (
            <div key={video.id}
              className="group rounded-2xl overflow-hidden cursor-pointer transition-all duration-200 hover:scale-[1.01]"
              style={{ background: '#12141E', border: '1px solid rgba(255,255,255,0.06)' }}
              onClick={() => setPlayingVideo(video)}>
              {/* Thumbnail */}
              <div className="relative overflow-hidden" style={{ paddingTop: '56.25%' }}>
                <img src={video.thumbnail} alt={video.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105" />
                <div className="absolute inset-0 flex items-center justify-center"
                  style={{ background: 'rgba(0,0,0,0.3)' }}>
                  <div className="w-14 h-14 rounded-full flex items-center justify-center transition-all duration-200 group-hover:scale-110"
                    style={{ background: 'rgba(245,166,35,0.9)', boxShadow: '0 0 30px rgba(245,166,35,0.4)' }}>
                    <i className="ri-play-fill text-white text-2xl ml-1" />
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-lg text-xs font-bold text-white"
                  style={{ background: 'rgba(0,0,0,0.75)' }}>
                  {video.duration}
                </div>
                {video.category !== 'hepsi' && categoryBadgeColors[video.category] && (
                  <div className="absolute top-2 left-2 px-2 py-0.5 rounded-lg text-xs font-semibold"
                    style={categoryBadgeColors[video.category]}>
                    {categoryLabels[video.category]}
                  </div>
                )}
              </div>
              {/* Info */}
              <div className="p-4">
                <h3 className="text-sm font-bold text-white leading-snug mb-2 group-hover:text-amber-400 transition-colors">{video.title}</h3>
                <div className="flex items-center gap-2 mb-2">
                  <div className="w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold text-white flex-shrink-0"
                    style={{ background: 'linear-gradient(135deg, #F5A623 0%, #FF6B35 100%)' }}>
                    {video.speaker.charAt(0)}
                  </div>
                  <div>
                    <span className="text-xs font-semibold text-gray-300">{video.speaker}</span>
                    <span className="text-xs text-gray-600 ml-1">— {video.speakerRole}</span>
                  </div>
                </div>
                <p className="text-xs text-gray-500 leading-relaxed line-clamp-2">{video.description}</p>
                <div className="flex items-center gap-3 mt-3 pt-3" style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}>
                  <div className="flex items-center gap-1 text-xs text-gray-600">
                    <i className="ri-eye-line" />
                    {video.views}
                  </div>
                  <div className="flex items-center gap-1 text-xs text-gray-600">
                    <i className="ri-time-line" />
                    {video.duration}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Kategori Filtreleri */}
      <div className="flex gap-2 flex-wrap">
        {(Object.keys(categoryLabels) as VideoCategory[]).map(cat => (
          <button key={cat} onClick={() => setActiveCategory(cat)}
            className="flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-medium cursor-pointer transition-all whitespace-nowrap"
            style={activeCategory === cat
              ? { background: 'linear-gradient(135deg, rgba(245,166,35,0.2) 0%, rgba(255,107,53,0.15) 100%)', color: '#F5A623', border: '1px solid rgba(245,166,35,0.3)' }
              : { background: 'rgba(255,255,255,0.04)', color: '#6B7280', border: '1px solid rgba(255,255,255,0.06)' }}>
            <div className="w-4 h-4 flex items-center justify-center">
              <i className={`${categoryIcons[cat]} text-xs ${activeCategory === cat ? 'text-amber-400' : categoryColors[cat]}`} />
            </div>
            {categoryLabels[cat]}
            <span className="ml-0.5 text-gray-600">({cat === 'hepsi' ? mockVideos.length : mockVideos.filter(v => v.category === cat).length})</span>
          </button>
        ))}
      </div>

      {/* Video Grid */}
      <div>
        <h2 className="text-sm font-bold text-white mb-4">
          {categoryLabels[activeCategory]}
          <span className="text-gray-600 font-normal ml-2 text-xs">— {filtered.length} video</span>
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {filtered.map(video => (
            <div key={video.id}
              className="group rounded-2xl overflow-hidden cursor-pointer transition-all duration-200 hover:scale-[1.02]"
              style={{ background: '#12141E', border: '1px solid rgba(255,255,255,0.06)' }}
              onClick={() => setPlayingVideo(video)}>
              {/* Thumbnail */}
              <div className="relative overflow-hidden" style={{ paddingTop: '56.25%' }}>
                <img src={video.thumbnail} alt={video.title}
                  className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-300 group-hover:scale-105" />
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity"
                  style={{ background: 'rgba(0,0,0,0.45)' }}>
                  <div className="w-12 h-12 rounded-full flex items-center justify-center"
                    style={{ background: 'rgba(245,166,35,0.9)' }}>
                    <i className="ri-play-fill text-white text-xl ml-0.5" />
                  </div>
                </div>
                <div className="absolute inset-0 flex items-center justify-center group-hover:opacity-0 transition-opacity">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center"
                    style={{ background: 'rgba(0,0,0,0.5)' }}>
                    <i className="ri-play-fill text-white text-lg ml-0.5" />
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-1.5 py-0.5 rounded text-xs font-bold text-white"
                  style={{ background: 'rgba(0,0,0,0.75)' }}>
                  {video.duration}
                </div>
              </div>
              {/* Info */}
              <div className="p-3">
                {video.category !== 'hepsi' && categoryBadgeColors[video.category] && (
                  <span className="inline-block text-xs px-1.5 py-0.5 rounded-md font-medium mb-2"
                    style={categoryBadgeColors[video.category]}>
                    {categoryLabels[video.category]}
                  </span>
                )}
                <h3 className="text-xs font-bold text-white leading-snug mb-2 group-hover:text-amber-400 transition-colors line-clamp-2">{video.title}</h3>
                <div className="flex items-center gap-1.5">
                  <div className="w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold text-white flex-shrink-0"
                    style={{ background: 'linear-gradient(135deg, #F5A623 0%, #FF6B35 100%)' }}>
                    {video.speaker.charAt(0)}
                  </div>
                  <span className="text-xs text-gray-500 truncate">{video.speaker}</span>
                </div>
                <div className="flex items-center gap-3 mt-2 pt-2" style={{ borderTop: '1px solid rgba(255,255,255,0.04)' }}>
                  <span className="text-xs text-gray-700 flex items-center gap-0.5">
                    <i className="ri-eye-line text-xs" />{video.views}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Video Player Modal ── */}
      {playingVideo && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4"
          style={{ background: 'rgba(0,0,0,0.85)', backdropFilter: 'blur(8px)' }}
          onClick={() => setPlayingVideo(null)}>
          <div className="w-full max-w-3xl rounded-2xl overflow-hidden"
            style={{ background: '#12141E', border: '1px solid rgba(255,255,255,0.1)' }}
            onClick={e => e.stopPropagation()}>
            {/* Modal Header */}
            <div className="flex items-start justify-between gap-3 p-4" style={{ borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-bold text-white leading-snug mb-1">{playingVideo.title}</h3>
                <div className="flex items-center gap-2">
                  <span className="text-xs text-gray-400">{playingVideo.speaker}</span>
                  <span className="text-gray-700">·</span>
                  <span className="text-xs text-gray-600">{playingVideo.speakerRole}</span>
                  {playingVideo.category !== 'hepsi' && categoryBadgeColors[playingVideo.category] && (
                    <span className="text-xs px-1.5 py-0.5 rounded-md font-medium"
                      style={categoryBadgeColors[playingVideo.category]}>
                      {categoryLabels[playingVideo.category]}
                    </span>
                  )}
                </div>
              </div>
              <button onClick={() => setPlayingVideo(null)}
                className="w-8 h-8 rounded-xl flex items-center justify-center cursor-pointer flex-shrink-0 text-gray-400 hover:text-white transition-colors"
                style={{ background: 'rgba(255,255,255,0.06)' }}>
                <i className="ri-close-line text-base" />
              </button>
            </div>

            {/* Video Embed */}
            <div className="relative w-full" style={{ paddingTop: '56.25%', background: '#000' }}>
              <iframe
                className="absolute inset-0 w-full h-full"
                src={`https://www.youtube.com/embed/${playingVideo.youtubeId}?autoplay=1`}
                title={playingVideo.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>

            {/* Modal Footer */}
            <div className="p-4">
              <p className="text-xs text-gray-400 leading-relaxed mb-3">{playingVideo.description}</p>
              <div className="flex items-center gap-4">
                <span className="text-xs text-gray-600 flex items-center gap-1">
                  <i className="ri-eye-line" />{playingVideo.views} izlenme
                </span>
                <span className="text-xs text-gray-600 flex items-center gap-1">
                  <i className="ri-time-line" />{playingVideo.duration}
                </span>
                <a href={`https://youtube.com/watch?v=${playingVideo.youtubeId}`}
                  target="_blank" rel="noopener noreferrer"
                  className="ml-auto flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-semibold text-white cursor-pointer whitespace-nowrap transition-all hover:opacity-90"
                  style={{ background: 'rgba(255,0,0,0.7)' }}>
                  <i className="ri-youtube-line" /> YouTube'da Aç
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
